import React from 'react';
import { Body, Box, Container, Heading } from '@hover/blueprint';

interface Props {
  heroLinks: React.ReactNode | null;
  revisedDate: string;
}

const PrivacyHero: React.FC<Props> = ({ heroLinks, revisedDate }) => (
  <Box w="100%" bg="orange.100" justifyContent="center" mb="56px">
    <Container
      maxW="1300px"
      pt="28px"
      px={{ base: 500, tablet: '56px' }}
      pb={{ base: 800, tablet: '84px' }}
    >
      <Body
        textTransform="uppercase"
        isBold
        size={300}
        color="brandNavy.300"
        letterSpacing="0.1rem"
      >
        {revisedDate}
      </Body>
      {heroLinks}
      <Heading
        as="h1"
        color="brandNavy.500"
        style={{ marginBottom: 0 }}
        size={{ base: 500, tablet: 700, desktop: 800 }}
      >
        HOVER Privacy Policy
      </Heading>
    </Container>
  </Box>
);

export default PrivacyHero;
